import { FC, InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export const Checkbox: FC<
  InputHTMLAttributes<HTMLInputElement> & {
    label?: React.ReactNode;
    error?: boolean;
  }
> = ({ children, label, error, ...inputProps }) => {
  return (
    <div className="flex gap-2">
      <div className="relative">
        <input
          {...inputProps}
          type="checkbox"
          className={twMerge(
            "appearance-none w-5 h-5 border-[1px] shrink-0 border-secondary rounded bg-white checked:bg-secondary checked:border-0 relative peer",
            inputProps.className,
            error && "border-red-500",
          )}
        />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="absolute top-0 hidden peer-checked:block pointer-events-none"
        >
          <path
            d="M7.33329 13.25L3.83329 9.74996L2.66663 10.9166L7.33329 15.5833L17.3333 5.58329L16.1666 4.41663L7.33329 13.25Z"
            fill="white"
          />
        </svg>
      </div>
      {label && <label htmlFor={inputProps.id}>{label}</label>}
    </div>
  );
};
